import { Button, FormTextArea, LoadingIndicator, useModal } from '../../../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { rejeitaNota } from '../../core/_requests'
import { useFormik } from 'formik'
import { rejeitarNotaSchema } from './validation/rejeitarNotaSchema'

type IProps = {
  idNota: number
}

export const RejeitarNotaModal = ({ idNota }: IProps) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      motivo: '',
    },
    validationSchema: rejeitarNotaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        await rejeitaNota(idNota, values.motivo)
        showAlert({ title: 'Sucesso', text: 'Nota rejeitada com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormTextArea
        formik={formik}
        name='motivo'
        label='Motivo'
        placeholder='Digite o motivo'
        isDisabled={formik.isSubmitting}
      />

      <div className='d-flex justify-content-center mt-5'>
        <Button className='btn-secondary me-2' onClick={closeModal}>
          Cancelar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Enviar'}
        </Button>
      </div>
    </form>
  )
}
